import React from 'react';
import './PricingPlanFeature.scss';
import { Help } from 'components/Icons/Help';

export type PricingPlanFeatureDocument = {
    __typename: string;
    data: {
        title: string;
        sub_features: Array<{
            label: string;
            tooltip: string;
        }>;
    };
};

export type PricingPlanFeatureProps = {
    index: number;
    feature: PricingPlanFeatureDocument;
};

export class PricingPlanFeature extends React.Component<PricingPlanFeatureProps> {
    render() {
        const feature = this.props.feature.data;

        return (
            <div className="PricingPlanFeature">
                <h4 className="PricingPlanFeature-label">{feature.title}</h4>
                <ul className="PricingPlanFeature-content">
                    {feature.sub_features.map(subFeature => {
                        const tooltipAttributes = {
                            tooltips: 'tooltips',
                            'tooltip-title': subFeature.tooltip,
                            'tooltip-side': 'top',
                        };

                        return (
                            <li
                                className="PricingPlanFeature-content-item"
                                key={`${this.props.index}_${subFeature.label}`}
                            >
                                <span className="label">{subFeature.label}</span>
                                <span className="tooltip" {...tooltipAttributes}>
                                    <Help />
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}
